import { FC, PropsWithChildren } from 'react'
import CollapseCard from '@/components/CollapseCard'
import Table from './Table'
import DkpTable from './DkpTable'
import DkpjzTable from './DkpjzTable'
import DskjzTable from './DskjzTable'

type PropType = FC<PropsWithChildren<{
  className?: string
  count: any
}>>

const MyEntrust: PropType = ({ className, count }) => {
  return (
    <CollapseCard
      title="非审批类-财务事项"
      className={className}
      items={
        [
          {label: `待开票（${count.CNT_FSPLCWSX_DKP || 0}）`, key: '待开票', children: <DkpTable />},
          {label: `待开票记账（${count.CNT_FSPLCWSX_DKPJZ || 0}）`, key: '待开票记账', children: <DkpjzTable />},
          {label: `待收款记账（${count.CNT_FSPLCWSX_DSKJZ || 0}）`, key: '待收款记账', children: <DskjzTable />},
        ]
      }
    />
  )
}

export default MyEntrust
